import React from 'react';
import { Maximize2, Shrink } from 'lucide-react';

export function WorkflowConfigPanelMaximizeButton({
  expanded,
  onToggle,
}: {
  expanded: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      className="workflow-config-panel-max-btn"
      onClick={onToggle}
      aria-expanded={expanded}
      aria-label={expanded ? 'Restore default panel width' : 'Expand panel to half of the page width'}
      title={expanded ? 'Restore' : 'Maximize'}
    >
      {expanded ? <Shrink size={17} strokeWidth={2} aria-hidden /> : <Maximize2 size={17} strokeWidth={2} aria-hidden />}
    </button>
  );
}

type WorkflowConfigPanelFrameProps = {
  expanded: boolean;
  children: React.ReactNode;
};

/**
 * Wraps node config side panels — width only; maximize lives beside each panel’s close control.
 */
export default function WorkflowConfigPanelFrame({ expanded, children }: WorkflowConfigPanelFrameProps) {
  return (
    <div
      className={`workflow-config-panel-frame nokey${expanded ? ' workflow-config-panel-frame--expanded' : ''}`}
    >
      <div className="workflow-config-panel-frame__body">{children}</div>
    </div>
  );
}
